<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'
import LoginStart from '@/components/views/manage-account/LoginStart.vue'
import LoginEnd from '@/components/views/manage-account/LoginEnd.vue'

const store = useStore()

const formSubmitted = computed(() => store.state.auth.formSubmitted)
</script>

<template>
  <Transition name="sa-auth-flow" mode="out-in">
    <LoginStart v-if="!formSubmitted" key="login-start" />
    <LoginEnd v-else key="login-end" />
  </Transition>
</template>
